import { components } from "react-select";
import {
  AmcContractStatus,
  amcStatusMap,
} from "features/Amc/constants/amc-contract.constants";
import { formatCurrency } from "utils/currency";

export interface AmcSelectOption {
  value: number;
  label: string;
  title?: string | null;
  status?: string | null;
  agreedAmount?: number | null;
}

function AmcStatusBadge({ status }: { status: string | undefined | null }) {
  if (!status) return null;
  const entry = amcStatusMap[status as AmcContractStatus];
  if (!entry) return null;
  return (
    <span className={`badge bg-${entry.color}-subtle text-${entry.color} ms-1`}>
      {entry.label}
    </span>
  );
}

export function AmcOption(props: any) {
  const data = props.data as AmcSelectOption;
  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-medium text-body">{data.label}</span>
          <AmcStatusBadge status={data.status} />
        </div>
        {data.title?.trim() ? (
          <small className="text-muted text-truncate">{data.title.trim()}</small>
        ) : null}
        {data.agreedAmount != null && Number.isFinite(data.agreedAmount) ? (
          <small className="text-muted mt-1">
            Amount: <span className="text-body">{formatCurrency(data.agreedAmount)}</span>
          </small>
        ) : null}
      </div>
    </components.Option>
  );
}

export function AmcSingleValue(props: any) {
  const data = props.data as AmcSelectOption;
  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 min-w-0 text-truncate">
        <span className="text-truncate">{data.label}</span>
        {data.title?.trim() ? (
          <span className="text-muted text-truncate small">
            · {data.title.trim()}
          </span>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
